<template>
    <div class="button-loader">
        <general-loader :type="type" />
    </div>
</template>

<script>
import GeneralLoader from './GeneralLoader';

export default {
    name: 'button-loader',
    components: {
        GeneralLoader
    },
    props: {
        type: {
            type: String,
            default: 'normal',
            validator: (value) => {
                return ['large', 'normal', 'small'].indexOf(value) !== -1;
            }
        }
    }
}
</script>